<template>
  <div :class="['base-card', themeClass ]">
    <slot></slot>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

export default defineComponent({
  props: {
    theme: {
      type: String,
      required: false,
      default: ''
    }
  },
  setup(props) {
    const themeClass = computed(() => `base-card--${props.theme}`)

    return {
      themeClass
    }
  }
})
</script>
<style lang="scss">
.base-card {
  background-color: color(background-blue-4);
  border: 1px solid color(border-blue-3);
  padding: measure(half);
}

.base-card--grey {
  background-color: color(gray-5);
  border: 1px solid color(gray-4);
}
</style>
